import { Col, NewDateInput, Row, SelectInput, TextInput } from '@digitools/honest-react';
import React, { useState } from 'react';
import { optionalFieldCharacters } from 'src/utils/validationUtils';
import { LCI_EMPLOYEE_REASON_FOR_CHANGE } from '../../../constants/LCIConstant';
import { validateDateIsOnOrBeforeToday } from 'src/packages/cli/utils/validationUtils';
import { dateMask } from 'src/packages/eoi/utils/InputMasks';
import useTranslate from 'src/hooks/useTranslate';
import { parse } from 'date-fns';
import { LciValidationLabels } from '../../../constants/LciValidationLabels';
/*
 ****** Important Dates ****
 */
const ImportantDateInformation = ({ claimant, event }) => {
    const [employeeReason, setReason] = useState('');
    const { t } = useTranslate();
    const validateReason = (input) => {
        setReason(input);
    };
    let showDateOfDeath = false;
    let showDependentEffectiveDate = false;
    let showDateOfDisability = false;
    let showReasonForLeaving = false;
    switch (event) {
        case 'death':
            showDateOfDeath = true;
            if (claimant === 'dependent') {
                showDependentEffectiveDate = true;
            }
            break;
        case 'accelerated death':
            if (claimant === 'dependent') {
                showDependentEffectiveDate = true;
            }
            break;
        case `dismemberment / loss of sight`:
            if (claimant === 'dependent') {
                showDependentEffectiveDate = true;
            }
            break;
        case 'total disability':
            showDateOfDisability = true;
            showReasonForLeaving = true;
            break;
    }
    return (<>
      <Row className={'mt-0'}>
        <Col xl={4} md={6} sm={12} className={'mt-3'}>
          <NewDateInput data-testid='policyInfo_dateEmployed' field={'policyInfo_dateEmployed'} label={'Date employed'} data-private={true} ariaLabelText={'Date employed'} required={true} validate={(props) => validateDateIsOnOrBeforeToday(props, t, LciValidationLabels.dateEmployed)} minDate={parse('01/01/1900', 'P', new Date())} maxDate={new Date()}/>
        </Col>
        <Col xl={4} md={6} sm={12} className={'mt-3'}>
          <NewDateInput data-testid='policyInfo_lastWorked' field={'policyInfo_lastWorked'} label={'Last worked'} ariaLabelText={'Last worked'} data-private={true} required={true} validate={(props) => validateDateIsOnOrBeforeToday(props, t, LciValidationLabels.lastWorked)} minDate={parse('01/01/1900', 'P', new Date())} maxDate={new Date()}/>
        </Col>
        <Col xl={4} md={6} sm={12} className={'mt-3'}>
          <NewDateInput data-testid='policyInfo_lastPaid' field={'policyInfo_lastPaid'} label={'Date premium last paid'} optional={true} ariaLabelText={'Date premium last paid'} data-private={true} validate={(props) => validateDateIsOnOrBeforeToday(props, t, LciValidationLabels.datePremiumLastPaid)} minDate={parse('01/01/1900', 'P', new Date())} maxDate={new Date()}/>
        </Col>

        {showDateOfDisability && (<Col xl={4} md={6} sm={12}>
            <NewDateInput data-testid='policyInfo_dateOfDisability' field={'policyInfo_dateOfDisability'} label={'Date of disability'} ariaLabelText={'Date of disability'} data-private={true} required={true} validate={(props) => validateDateIsOnOrBeforeToday(props, t, LciValidationLabels.dateOfDisability)}/>
          </Col>)}

        {showReasonForLeaving && (<Col xl={4} md={6} sm={12} className={(event === 'total disability' ? 'mt-0' : 'mt-3')}>
            <TextInput field={'policyInfo_reasonForLeaving'} ariaLabelText={'Reason for leaving work'} label={'Reason for leaving work (optional)'} mask={optionalFieldCharacters} type={'text'} validateOnBlur={true}/>
          </Col>)}

        {showDateOfDeath && claimant !== 'dependent' && (<Col xl={4} md={6} sm={12}>
            <NewDateInput data-testid='policyInfo_dateOfDeath' field={'policyInfo_dateOfDeath'} label={'Date of death'} ariaLabelText={'Date of death'} data-private={true} optional={true} validate={(props) => validateDateIsOnOrBeforeToday(props, t, LciValidationLabels.dateOfDeath)} mask={dateMask}/>
          </Col>)}

        {showDependentEffectiveDate && (<Col xl={4} md={6} sm={12}>
            <NewDateInput data-testid='policyInfo_dependentEffectiveDate' field={'policyInfo_dependentEffectiveDate'} label={'Dependent\'s coverage effective date'} optional={true} validate={(props) => validateDateIsOnOrBeforeToday(props, t, LciValidationLabels.dependentEffectiveDate)} mask={dateMask}/>
          </Col>)}

        <Col xl={4} md={6} sm={12}>
          <NewDateInput data-testid='policyInfo_dateBenefitChange' field={'policyInfo_dateBenefitChange'} label={'Last benefits change date'} ariaLabelText={'Last increase/decrease in benefits'} data-private={true} optional={true} validate={(props) => validateDateIsOnOrBeforeToday(props, t, LciValidationLabels.lastBenefitsChangeDate)} mask={dateMask}/>
        </Col>

        <Col xl={4} md={6} sm={12}>
          <SelectInput field={'policyInfo_reason'} label={'Reason'} data-private={true} options={LCI_EMPLOYEE_REASON_FOR_CHANGE} optional={true} validate={validateReason} validateOnChange={true} placeholderText={'Reason'}/>
        </Col>
        {employeeReason == 'Other' && (<Col xl={4} md={6} sm={12}>
            <TextInput field={'policyInfo_otherReason'} ariaLabelText={'Please explain:'} label={'Please explain:'} mask={optionalFieldCharacters} required={true} validateOnBlur={true} type={'text'}/>
          </Col>)}
      </Row>
    </>);
};
export default ImportantDateInformation;
